export default String.raw`
{% if tableView -%}
	{% if product.AttributesPolyvalent[0] -%}
		{% assign trueActiveProduct = 'polyvalent' -%}
	{% else -%}
		{% assign trueActiveProduct = activeProduct -%}
	{% endif -%}
{% endif -%}

{% if include != null -%}
	{% assign activeProduct = include -%}
  	{% assign stockLevel = activeProduct.StockLevel -%}
  	{% if page.PageId == config.DefinedPages.ProductDetails.Id and product.Batch -%}
  		{% assign activeProduct = product -%}
  		{% assign stockLevel = include -%}
  	{% endif -%}
{% endif -%}

{% if unitName == null -%}
  	{% assign unitName = activeProduct.SaleUnit -%}
  	{% assign showUnit = true -%}
{% endif -%}

{% if stockLevel -%}
	{% assign stockValue = stockLevel.Value -%}
	{% assign stockValueString = stockValue | ToString | Split: "," -%}
	{% if config.Products.DecimalUnits == false -%}
	    {% assign stockValue = stockValueString[0] -%}
	{% else -%}
	    {% assign stockValue = stockLevel.Value | Round:4 | Normalize -%}
	{% endif -%}
{% endif -%}

{% assign maxInputQuantityValue = 99999 -%}

{% if stockLevel and stockLevel.QuantityControl -%}
	{% if noSupplyProductOnControlledStock -%}
		{% assign max = maxInputQuantityValue -%}
	{% else -%}
		{% capture max -%}{{ stockValue }}{% endcapture -%}
	{% endif -%}
	{% if stockValue == "0" or stockValue == 0 -%}
	  	{% assign min = 0 -%}
	  	{% if config.Products.DecimalUnits -%}
			{% capture min -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
		{% endif -%}
	{% elseif config.Products.DecimalUnits == false -%}
	  	{% assign min = 1 -%}
	{% else -%}
		{% comment -%}{% capture min -%}1{{ config.DecimalSeparator }}00{% endcapture -%}{% endcomment -%}
		{% capture min -%}0{{ config.DecimalSeparator }}01{% endcapture -%}
	{% endif -%}
{% elseif config.Products.DecimalUnits == false -%}
	{% assign max = maxInputQuantityValue -%}
	{% assign min = 1 -%}
{% else -%}
	{% assign max = maxInputQuantityValue -%}
	{% capture min -%}0{{ config.DecimalSeparator }}01{% endcapture -%}
{% endif -%}

{% assign minQ = 0 -%}
{% if page.PageId == config.DefinedPages.Order.Id and product.MinQuantity -%}
    {% assign min = product.MinQuantity | Normalize -%}
	{% assign minQ = product.MinQuantity | Normalize -%}
{% endif -%}

{% if activeProduct.BasicUnitMinQuantity -%}
    {% assign minQ = activeProduct.BasicUnitMinQuantity | Normalize -%}
{% endif -%}

{% if stockLevel and stockLevel.Control and page.PageId == config.DefinedPages.ProductDetails.Id -%}
	{% assign stockValue = stockLevel.Value -%}
	{% if stockValue != 0 -%}
		{% if config.Products.DecimalUnits == false -%}
			{% assign firstDigit = stockValueString[1] | First | ToNum -%}
			{% if firstDigit >= 5 -%}
				{% assign stockValue = stockValue | Round:0 | Minus: 1 -%}
			{% else -%}
				{% assign stockValue = stockValue | Round:0 -%}
			{% endif -%}
			{% assign stockValue = stockValue | DividedBy: unitRatio | Times: product.BasicUnitRatio -%}
			{% assign stockValueString = stockValue | ToString | Split: "," -%}
			{% assign stockValueStringSize = stockValueString | Size -%}
			{% if stockValueStringSize > 1 -%}
				{% if stockValueString[1] contains '999999' -%}
					{% assign stockValue = stockValue | Round:0 -%}
				{% else -%}
					{% assign stockValue = stockValueString[0] -%}
				{% endif -%}
			{% endif -%}
		{% else -%}
			{% assign stockValue = stockValue | DividedBy: unitRatio | Times: product.BasicUnitRatio | Round: 4 | Normalize -%}
		{% endif -%}
	{% else -%}
		{% assign stockValue = stockValue | Normalize -%}
	{% endif -%}
	{% if stockLevel.QuantityControl -%}
		{% if noSupplyProductOnControlledStock -%}
			{% assign max = maxInputQuantityValue -%}
		{% else -%}
			{% assign max = stockValue -%}
		{% endif -%}
	{% endif -%}
{% endif -%}

{% assign validationChangableClass = '' -%}
{% assign reloadClass = '' -%}
{% assign lastQuantityAttr = '' -%}

{% if min > max and max != 0 -%}
	{% assign min = max -%}
{% endif -%}

{% if config.Products.DecimalUnits -%}
	{% capture inputValue -%}1{{ config.DecimalSeparator }}00{% endcapture -%}
{% else -%}
	{% assign inputValue = 1 -%}
{% endif -%}

{% if inputValue > max and max != 0 -%}
	{% assign inputValue = max -%}
{% endif -%}

{% if inputValue >= 0.01 -%}
	{% if config.Products.DecimalUnits or inputValue >= 1 -%}
		{% assign canBuy = true -%}
	{% endif -%}
{% endif -%}

{% if tableView and graphicalVariants == false -%}
	{% if config.Products.DecimalUnits -%}
		{% capture inputValue -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
	{% else -%}
		{% assign inputValue = 0 -%}
	{% endif -%}

	{% assign min = 0 -%}
	{% if config.Products.DecimalUnits -%}
		{% capture min -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
	{% endif -%}
	{% assign zeroAllowedClass = 'zero-allowed-js' -%}
	{% if trueActiveProduct != 'polyvalent' -%}
		{% if activeProduct.Id != trueActiveProduct.Id -%}
			{% assign inputValue = 0 -%}
			{% if config.Products.DecimalUnits -%}
				{% capture inputValue -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
			{% endif -%}
		{% endif -%}
	{% else -%}
		{% assign inputValue = 0 -%}
		{% if config.Products.DecimalUnits -%}
			{% capture inputValue -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
		{% endif -%}
	{% endif -%}
{% endif -%}

{% if page.PageId == config.DefinedPages.ProductList.Id -%}
    {% assign validationChangableClass = 'changeable-js' -%}
{% endif -%}

{% if page.PageId == config.DefinedPages.Order.Id -%}
    {% capture lastQuantityAttr -%} data-last-proper-quantity="{{ product.Quantity | Normalize }}" {% endcapture -%}
	{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
		{% assign validationWithUnitRatioInfoClass = 'with-unit-ratio-info' -%} 
	{% endif -%}
{% endif -%}

{% assign complaintOrReturn = false -%}

{% if page.PageId == config.DefinedPages.Order.Id or page.PageId == config.DefinedPages.CustomerProfile.Id -%}
  	{% assign reloadClass = 'parent-container-reload-js' -%}
	{% if type == 'complaint' or type == 'return' -%}
		{% assign reloadClass = '' -%}
		{% assign complaintOrReturn = true -%}
		{% assign max = product.Quantity | Normalize -%}
	{% endif -%}
  	{% assign inputValue = product.Quantity | Normalize -%}
  	{% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
		{% if page.QueryString contains 'wishlist-details' or page.QueryString contains 'tab=wishlist' -%}
			{% assign inputValue = quantity | Normalize -%}
			{% assign depositValue = product.DepositValue | Times: productBasicUnitRatio -%}
			{% assign min = 1 -%}
			{% if config.Products.DecimalUnits -%}
				{% capture min -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
			{% endif -%}
			{% if product.SaleUnit <> productUnit -%}
				{% assign priceNumber = product.Price | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice -%}
			{% else -%}
				{% assign priceNumber = product.Price -%}
			{% endif -%}
		{% endif -%}
  	{% endif -%}
  	{% if config.Products.DecimalUnits -%}
	  	{% assign oldInputValue = inputValue -%}
		{% assign inputValueArray = inputValue | ToString | Split: config.DecimalSeparator -%}
		{% assign inputValueArraySize = inputValueArray | Size -%}
		{% if inputValueArraySize > 1 -%}
			{% assign decimalSize = inputValueArray[1] | Size -%}
			{% if decimalSize == 1 -%}
				{% capture inputValue -%}{{ inputValue }}0{% endcapture -%}
			{% endif -%}
		{% else -%}
			{% capture inputValue -%}{{ inputValue }}{{ config.DecimalSeparator }}00{% endcapture -%}
		{% endif -%}
	{% endif -%}
{% endif -%}

{% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
	{% if unitMultiplicity > 0 and tableView == false -%}
		{% assign inputValue = unitMultiplicity -%}
		{% assign min = unitMultiplicity -%}
	{% elseif activeProduct.BasicUnitMultiplicity > 0 and tableView -%}
		{% assign unitMultiplicity = activeProduct.BasicUnitMultiplicity -%}
	{% else -%}
		{% assign unitMultiplicity = 0 -%}
	{% endif -%}
{% elseif product.Multiplicity > 0 -%}
	{% assign unitMultiplicity = product.Multiplicity -%}
	{% if config.Products.DecimalUnits -%}
		{% assign inputValue = oldInputValue -%}
	{% endif -%}
	{% assign afterMinus = inputValue | Minus: product.Multiplicity -%}
	{% if afterMinus < min -%}
		{% assign min = inputValue -%}
		{% assign minQ = inputValue -%}
	{% endif -%}
{% elseif product.BasicUnitMultiplicity > 0 -%}
	{% assign unitMultiplicity = product.BasicUnitMultiplicity -%}
	{% if viewDesktop != 'quick-shopping' -%}
		{% assign inputValue = product.BasicUnitMultiplicity -%}
	{% else -%}
		{% assign inputValue = 0 -%}
	{% endif -%}
{% else -%}
	{% assign unitMultiplicity = 0 -%}
{% endif -%}

{% assign unitNames = activeProduct.SaleUnit -%}
{% assign unitRatios = "1" -%}
{% if activeProduct.Units -%}
	{% assign unitNames = '' -%}
	{% assign unitRatios = '' -%}

	{% for unit in activeProduct.Units -%}
		{% assign stringRatio = unit.Ratio | ToString -%}
		{% assign unitNames = unitNames | Append: unit.Name | Append: ',' -%}
		{% assign unitRatios = unitRatios | Append: stringRatio | Append: ',' -%}
	{% endfor -%}

	{% assign unitNamesLenght = unitNames | Size | Minus: 1 -%}
	{% assign unitRatiosLenght = unitRatios | Size | Minus: 1 -%}

	{% if unitNamesLenght > 0 -%}
		{% assign unitNames = unitNames | Slice: 0, unitNamesLenght -%}
		{% assign unitRatios = unitRatios | Slice: 0, unitRatiosLenght -%}
	{% endif -%}
{% endif -%}

{% if canBuy -%}
	<span class="quantity">
		<button aria-label="{{ translations.DecreaseQuantity }}" class="quantity__minus {% if tableView -%} change-quantity-in-table-js {% elseif product.IsEdited != null and complaintOrReturn == false -%} order-editing-quantity-change-js {% else -%} change-quantity-js {% endif -%} decrement-js {{reloadClass}} {% if inputValue == min or min >= max -%} disabled-js" disabled {% else -%}"{% endif -%}>
			<svg class="icon">
				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#minus-{{settings.iconStyle}}"></use>
			</svg>
		</button>
		<input aria-label="{{ translations.ChangeQuantity }}" class="quantity__input {{validationChangableClass}} {{reloadClass}} {{zeroAllowedClass}} {% if product.IsEdited != null and complaintOrReturn == false -%} order-editing-quantity-js {% endif -%}" type="text" name="quantity" value="{{inputValue}}" data-min="{{min}}" data-max="{{ max }}" aria-label="{{ translations.ChangeQuantity }}" {% if minQ -%} data-minq="{{minQ}}" {% endif -%} {% if unitMultiplicity > 0 -%} data-multiplicity="{{unitMultiplicity}}" {% endif -%} data-name="{{product.NameNoHtml | H}}" data-no="{{product.No}}" data-price-number="{% if totalPrice -%}{{totalPrice}}{% elseif price -%}{{price}}{% else -%}{{product.Price}}{% endif -%}" data-deposit="{{ depositValue }}" data-price="{{ product.Price | ToPrice }}" {{lastQuantityAttr}} data-unit-names="{{ unitNames }}" data-unit-ratios="{{ unitRatios }}" data-id="{{ activeProduct.Id}}">
		<button aria-label="{{ translations.IncreaseQuantity }}" class="quantity__plus {% if tableView -%} change-quantity-in-table-js {% elseif product.IsEdited != null and complaintOrReturn == false -%} order-editing-quantity-change-js {% else -%} change-quantity-js {% endif -%} increment-js {{reloadClass}} {% if inputValue == max or min >= max -%} disabled-js" disabled {% else -%}"{% endif -%}>
			<svg class="icon">
				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
			</svg>
		</button>
	</span>
{% endif -%}

{% if tableView -%}
	{% unless product.AttributesPolyvalent[0] -%}
		{% assign activeProduct = trueActiveProduct -%}
	{% endunless -%}
{% endif -%}
`